import React from 'react'

export const WhyTrade = ({content}) => {
    return (
        <div className='why-trade-wrapper'>
            <h1>{content.title}</h1>
            <p>{content.subtitle}</p>
            <div className='cards'>
                {
                    content.cards.map((card, index) => (
                        <div className='my-card' key={index}>
                            <img src={card.img} />
                            <p className='card-title'>{card.title}</p>
                            <p className='card-subtitle'>{card.subtitle}</p>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}